import { render } from "./ContactPage.vue?vue&type=template&id=7209f1d0&scoped=true&ts=true"
import script from "./ContactPage.vue?vue&type=script&lang=ts"
export * from "./ContactPage.vue?vue&type=script&lang=ts"

import "./ContactPage.vue?vue&type=style&index=0&id=7209f1d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7209f1d0"]])

export default __exports__